import { z } from 'zod';
const ManifestSchema = z.object({
  versions: z.array(
    z.object({
      id: z.string(),
      type: z.string(),
      url: z.string().url(),
      releaseTime: z.string().datetime({ offset: true }),
    }),
  ),
});
export class VersionCatalog {
  private constructor(private readonly versions: z.infer<typeof ManifestSchema>['versions']) {}
  static fromMojangManifest(json: unknown): VersionCatalog {
    return new VersionCatalog(ManifestSchema.parse(json).versions);
  }
  private get(id: string) {
    const v = this.versions.find((v) => v.id === id);
    if (!v) throw new Error(`Unknown Minecraft version: ${id}`);
    return v;
  }
  compare(a: string, b: string): number {
    return Math.sign(Date.parse(this.get(a).releaseTime) - Date.parse(this.get(b).releaseTime));
  }
  isDowngrade(from: string, to: string): boolean {
    return this.compare(from, to) > 0;
  }
  list({ includeSnapshots = false }: { includeSnapshots?: boolean } = {}): string[] {
    return this.versions
      .filter((v) => includeSnapshots || v.type === 'release')
      .toSorted((a, b) => Date.parse(b.releaseTime) - Date.parse(a.releaseTime))
      .map((v) => v.id);
  }
}
export function checkDataVersion(levelDataVersion: number, targetDataVersion: number): string | undefined {
  if (![levelDataVersion, targetDataVersion].every((v) => Number.isInteger(v) && v >= 0))
    throw new Error('Invalid DataVersion');
  return levelDataVersion > targetDataVersion
    ? `World DataVersion ${levelDataVersion} exceeds target ${targetDataVersion}`
    : undefined;
}
